// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Feed Filter Dropdown Styles */
.uac-feed-filter-section {
    margin-bottom: 20px;
    padding: 0 10px;
  }
  
  /* .feed-filter-dropdown-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 200px;
    margin-left: 450px;
  } */

  .feed-filter-dropdown-wrapper {
    position: relative;
    display: inline-block;
    
    /* ✅ Base styles */
    width: 100%;
    max-width: 200px;
    min-width: 150px;
    
    /* ✅ Default (Mobile First) */
    margin: 12px 0;
  }
  
  /* ✅ Small Devices (480px - 767px) */
  @media (min-width: 480px) and (max-width: 767px) {
    .feed-filter-dropdown-wrapper {
      width: 100%;
      margin: 10px auto;
    }
  }
  
  /* ✅ Tablets (768px - 1023px) */
  @media (min-width: 768px) and (max-width: 1023px) {
    .feed-filter-dropdown-wrapper {
      margin-left: 200px;
      margin-right: 100px;
    }
  }
  
  /* ✅ Large Desktop (1024px - 1199px) */
  @media (min-width: 1024px) and (max-width: 1199px) {
    .feed-filter-dropdown-wrapper {
      margin-left: 300px;
      margin-right: 100px;
    }
  }
  
  /* ✅ Extra Large Desktop (1200px+) */
  @media (min-width: 1200px) and (max-width: 1600px) {
    .feed-filter-dropdown-wrapper {
      margin-left: 310px;
      margin-right: 0;
    }
  }

  @media (min-width: 1600px) {
    .feed-filter-dropdown-wrapper {
      margin-left: 450px;
      margin-right: 0;
    }
  }
  
  .feed-filter-dropdown-button {
    width: 100%;
    padding: 10px 15px;
    background: var(--card-bg, rgb(4, 4, 4));
    border: 1px solid var(--border-color, rgb(52, 51, 51));
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s ease;
    color: var(--text-primary, gray);
    margin-left: 10px;
  }
    
  .feed-filter-label {
    font-weight: 600;
  }
  
  .feed-filter-arrow {
    font-size: 10px;
    transition: transform 0.3s ease;
  }
  
  .feed-filter-dropdown-button[aria-expanded="true"] .feed-filter-arrow {
    transform: rotate(180deg);
  }
  
  .feed-filter-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--card-bg, rgb(4, 4, 4));
    border: 1px solid var(--border-color, rgb(52, 51, 51));
    border-top: none;
    border-radius: 0 0 8px 8px;
    /* box-shadow: 0 4px 6px rgba(174, 101, 101, 0.1); */
    z-index: 1000;
    overflow: hidden;
  }
  
  .feed-filter-option {
    display: block;
    width: 100%;
    padding: 12px 15px;
    background: none;
    border: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: var(--text-primary, white);
    transition: all 0.2s ease;
    border-bottom: 1px solid var(--border-color, #e0e0e0);
  }
  
  .feed-filter-option:last-child {
    border-bottom: none;
  }
      
  /* Post Card Styling */
  .uac-feed-wrapper {
    width: 100%;
    max-width: 100%;
  }
  
  .uacf-post-card {
    background: var(--card-bg, #ffffff);
    border: 1px solid var(--border-color, rgb(52, 51, 51));
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 16px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s ease;
    background: rgb(4, 4, 4);
  }
  
  .uacf-post-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .uacf-user-container {
    margin-bottom: 12px;
  }
  
  .uacf-user-info-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
  }
  
  .uacf-user-avatar-wrapper {
    flex-shrink: 0;
  }
  
  .tt-profile-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--border-color, #e0e0e0);
  }
  
  .uacf-user-name-wrapper {
    flex: 1 1;
  }
  
  .uacf-user-link {
    text-decoration: none;
    color: var(--text-header, #1a1a1a);
    font-weight: 600;
    font-size: 14px;
    transition: color 0.2s ease;
  }
  
  /* .uacf-user-link:hover {
    color: var(--primary-color, #007bff);
  } */
  
  .uacf-user-action {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .uacf-location-time-wrapper {
    margin-bottom: 10px;
    padding: 0 10px;
  }
  
  .uacf-location-link {
    text-decoration: none;
    color: var(--primary-color, #007bff);
    font-weight: 500;
    font-size: 13px;
    transition: color 0.2s ease;
  }
  
  .uacf-location-link:hover {
    text-decoration: underline;
  }
  
  .text-label {
    color: var(--text-secondary, #666666);
    font-size: 13px;
    margin: 0;
  }
  
  .uacf-post-description {
    color: var(--text-primary, #333333);
    font-size: 14px;
    line-height: 1.5;
    margin: 10px 0;
  }
  
  .uacf-feed-media {
    margin: 12px 0;
  }
  
  .uacf-feed-media-container {
    border-radius: 8px;
    overflow: hidden;
    margin-top: 10px;
  }
  
  .uacf-post-stats-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid var(--border-color, rgb(52, 51, 51));
    border-bottom: 1px solid var(--border-color, rgb(52, 51, 51));
    margin: 10px 0;
  }
  
  .uacf-post-stats-left {
    display: flex;
    gap: 15px;
  }
  
  .uacf-impressions-text {
    font-weight: 500;
    color: var(--text-secondary, #666666);
  }
  
  .uacf-comments-wrapper {
    margin-top: 12px;
  }
  
  .uacf-feed-comments {
    margin-bottom: 12px;
  }
  
  .uacf-comments-title {
    font-weight: 600;
    color: var(--text-primary, #333333);
    font-size: 13px;
    margin: 0 0 8px 0;
  }
  
  .comments-container {
    max-height: 300px;
    overflow-y: auto;
    border-radius: 4px;
  }
  
  .uacf-comment-item {
    padding: 8px;
    margin-bottom: 4px;
    background: var(--comment-bg, #f9f9f9);
    border-radius: 4px;
  }
  
  .uacf-comment-link {
    text-decoration: none;
    color: var(--text-primary, #333333);
    transition: color 0.2s ease;
  }
  
  .uacf-comment-link:hover {
    color: var(--primary-color, #007bff);
  }
  
  .uacf-no-comments {
    color: var(--text-secondary, #666666);
    font-size: 13px;
    font-style: italic;
    margin: 0;
    padding: 8px;
  }
  
  .uacf-add-comment {
    display: flex;
    gap: 8px;
    margin-top: 10px;
  }
  
  .uafc-comment-input {
    flex: 1 1;
    padding: 8px 12px;
    border: 1px solid var(--border-color, #e0e0e0);
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    transition: border-color 0.2s ease;
  }
  
  .uafc-comment-input:focus {
    outline: none;
    border-color: var(--primary-color, #007bff);
    box-shadow: 0 0 0 2px var(--primary-bg, rgba(0, 123, 255, 0.1));
  }
  
  .uafc-add-comment-button {
    padding: 8px 16px;
    background: var(--primary-color, #007bff);
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
  }
  
  .uafc-add-comment-button:hover {
    background: var(--primary-dark, #0056b3);
  }
  
  .uacf-loading,
  .uacf-error {
    text-align: center;
    padding: 40px 20px;
    color: var(--text-secondary, #666666);
  }
  
  .uacf-error {
    color: var(--error-color, #dc3545);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UserAccountGridLayout.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;;;;;KAMG;;EAEH;IACE,kBAAkB;IAClB,qBAAqB;;IAErB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA,oCAAoC;EACpC;IACE;MACE,WAAW;MACX,iBAAiB;IACnB;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA,sCAAsC;EACtC;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA,oCAAoC;EACpC;IACE;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,sDAAsD;IACtD,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,wCAAwC;IACxC,sDAAsD;IACtD,gBAAgB;IAChB,0BAA0B;IAC1B,oDAAoD;IACpD,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mCAAmC;IACnC,sDAAsD;IACtD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,qBAAqB;IACrB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;;KAEG;;EAEH;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,eAAe;IACf,SAAS;EACX;;EAEA;IACE,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,0DAA0D;IAC1D,6DAA6D;IAC7D,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,2CAA2C;IAC3C,+DAA+D;EACjE;;EAEA;IACE,iBAAiB;IACjB,yCAAyC;IACzC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,kCAAkC;EACpC","sourcesContent":["/* Feed Filter Dropdown Styles */\n.uac-feed-filter-section {\n    margin-bottom: 20px;\n    padding: 0 10px;\n  }\n  \n  /* .feed-filter-dropdown-wrapper {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    max-width: 200px;\n    margin-left: 450px;\n  } */\n\n  .feed-filter-dropdown-wrapper {\n    position: relative;\n    display: inline-block;\n    \n    /* ✅ Base styles */\n    width: 100%;\n    max-width: 200px;\n    min-width: 150px;\n    \n    /* ✅ Default (Mobile First) */\n    margin: 12px 0;\n  }\n  \n  /* ✅ Small Devices (480px - 767px) */\n  @media (min-width: 480px) and (max-width: 767px) {\n    .feed-filter-dropdown-wrapper {\n      width: 100%;\n      margin: 10px auto;\n    }\n  }\n  \n  /* ✅ Tablets (768px - 1023px) */\n  @media (min-width: 768px) and (max-width: 1023px) {\n    .feed-filter-dropdown-wrapper {\n      margin-left: 200px;\n      margin-right: 100px;\n    }\n  }\n  \n  /* ✅ Large Desktop (1024px - 1199px) */\n  @media (min-width: 1024px) and (max-width: 1199px) {\n    .feed-filter-dropdown-wrapper {\n      margin-left: 300px;\n      margin-right: 100px;\n    }\n  }\n  \n  /* ✅ Extra Large Desktop (1200px+) */\n  @media (min-width: 1200px) and (max-width: 1600px) {\n    .feed-filter-dropdown-wrapper {\n      margin-left: 310px;\n      margin-right: 0;\n    }\n  }\n\n  @media (min-width: 1600px) {\n    .feed-filter-dropdown-wrapper {\n      margin-left: 450px;\n      margin-right: 0;\n    }\n  }\n  \n  .feed-filter-dropdown-button {\n    width: 100%;\n    padding: 10px 15px;\n    background: var(--card-bg, rgb(4, 4, 4));\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: all 0.3s ease;\n    color: var(--text-primary, gray);\n    margin-left: 10px;\n  }\n    \n  .feed-filter-label {\n    font-weight: 600;\n  }\n  \n  .feed-filter-arrow {\n    font-size: 10px;\n    transition: transform 0.3s ease;\n  }\n  \n  .feed-filter-dropdown-button[aria-expanded=\"true\"] .feed-filter-arrow {\n    transform: rotate(180deg);\n  }\n  \n  .feed-filter-dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: var(--card-bg, rgb(4, 4, 4));\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n    /* box-shadow: 0 4px 6px rgba(174, 101, 101, 0.1); */\n    z-index: 1000;\n    overflow: hidden;\n  }\n  \n  .feed-filter-option {\n    display: block;\n    width: 100%;\n    padding: 12px 15px;\n    background: none;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--text-primary, white);\n    transition: all 0.2s ease;\n    border-bottom: 1px solid var(--border-color, #e0e0e0);\n  }\n  \n  .feed-filter-option:last-child {\n    border-bottom: none;\n  }\n      \n  /* Post Card Styling */\n  .uac-feed-wrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n  \n  .uacf-post-card {\n    background: var(--card-bg, #ffffff);\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 16px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    transition: box-shadow 0.3s ease;\n    background: rgb(4, 4, 4);\n  }\n  \n  .uacf-post-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .uacf-user-container {\n    margin-bottom: 12px;\n  }\n  \n  .uacf-user-info-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n  }\n  \n  .uacf-user-avatar-wrapper {\n    flex-shrink: 0;\n  }\n  \n  .tt-profile-image {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid var(--border-color, #e0e0e0);\n  }\n  \n  .uacf-user-name-wrapper {\n    flex: 1;\n  }\n  \n  .uacf-user-link {\n    text-decoration: none;\n    color: var(--text-header, #1a1a1a);\n    font-weight: 600;\n    font-size: 14px;\n    transition: color 0.2s ease;\n  }\n  \n  /* .uacf-user-link:hover {\n    color: var(--primary-color, #007bff);\n  } */\n  \n  .uacf-user-action {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n  \n  .uacf-location-time-wrapper {\n    margin-bottom: 10px;\n    padding: 0 10px;\n  }\n  \n  .uacf-location-link {\n    text-decoration: none;\n    color: var(--primary-color, #007bff);\n    font-weight: 500;\n    font-size: 13px;\n    transition: color 0.2s ease;\n  }\n  \n  .uacf-location-link:hover {\n    text-decoration: underline;\n  }\n  \n  .text-label {\n    color: var(--text-secondary, #666666);\n    font-size: 13px;\n    margin: 0;\n  }\n  \n  .uacf-post-description {\n    color: var(--text-primary, #333333);\n    font-size: 14px;\n    line-height: 1.5;\n    margin: 10px 0;\n  }\n  \n  .uacf-feed-media {\n    margin: 12px 0;\n  }\n  \n  .uacf-feed-media-container {\n    border-radius: 8px;\n    overflow: hidden;\n    margin-top: 10px;\n  }\n  \n  .uacf-post-stats-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-top: 1px solid var(--border-color, rgb(52, 51, 51));\n    border-bottom: 1px solid var(--border-color, rgb(52, 51, 51));\n    margin: 10px 0;\n  }\n  \n  .uacf-post-stats-left {\n    display: flex;\n    gap: 15px;\n  }\n  \n  .uacf-impressions-text {\n    font-weight: 500;\n    color: var(--text-secondary, #666666);\n  }\n  \n  .uacf-comments-wrapper {\n    margin-top: 12px;\n  }\n  \n  .uacf-feed-comments {\n    margin-bottom: 12px;\n  }\n  \n  .uacf-comments-title {\n    font-weight: 600;\n    color: var(--text-primary, #333333);\n    font-size: 13px;\n    margin: 0 0 8px 0;\n  }\n  \n  .comments-container {\n    max-height: 300px;\n    overflow-y: auto;\n    border-radius: 4px;\n  }\n  \n  .uacf-comment-item {\n    padding: 8px;\n    margin-bottom: 4px;\n    background: var(--comment-bg, #f9f9f9);\n    border-radius: 4px;\n  }\n  \n  .uacf-comment-link {\n    text-decoration: none;\n    color: var(--text-primary, #333333);\n    transition: color 0.2s ease;\n  }\n  \n  .uacf-comment-link:hover {\n    color: var(--primary-color, #007bff);\n  }\n  \n  .uacf-no-comments {\n    color: var(--text-secondary, #666666);\n    font-size: 13px;\n    font-style: italic;\n    margin: 0;\n    padding: 8px;\n  }\n  \n  .uacf-add-comment {\n    display: flex;\n    gap: 8px;\n    margin-top: 10px;\n  }\n  \n  .uafc-comment-input {\n    flex: 1;\n    padding: 8px 12px;\n    border: 1px solid var(--border-color, #e0e0e0);\n    border-radius: 4px;\n    font-size: 13px;\n    font-family: inherit;\n    transition: border-color 0.2s ease;\n  }\n  \n  .uafc-comment-input:focus {\n    outline: none;\n    border-color: var(--primary-color, #007bff);\n    box-shadow: 0 0 0 2px var(--primary-bg, rgba(0, 123, 255, 0.1));\n  }\n  \n  .uafc-add-comment-button {\n    padding: 8px 16px;\n    background: var(--primary-color, #007bff);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s ease;\n  }\n  \n  .uafc-add-comment-button:hover {\n    background: var(--primary-dark, #0056b3);\n  }\n  \n  .uacf-loading,\n  .uacf-error {\n    text-align: center;\n    padding: 40px 20px;\n    color: var(--text-secondary, #666666);\n  }\n  \n  .uacf-error {\n    color: var(--error-color, #dc3545);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
